
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Remonte automatiquement en haut de la page quand l'URL change
    window.scrollTo({
      top: 0,
      behavior: "smooth" // Pour un défilement fluide
    });
  }, [pathname]);

  return null; // Ce composant ne rend rien
};

export default ScrollToTop;
